import React from 'react'

export default function ViewCampaign() {
  return (
    <div>
      <h1>View Campaign</h1>
    </div>
  )
}
